import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';

import RegionService from '../../services/regionService';
import { GetInputTextTemplate } from '../../utils/formTemplates';
import { Region } from '../../models/region';

const RegionModal = (props: { region: Region; onSave: () => void; onHide: () => void }) => {
  const errors = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isNew] = useState<boolean>(!props.region.regionId);

  const regionService = new RegionService();

  const validationSchema = Yup.object().shape({
    regionId: Yup.string().nullable().required('Region id is required.').trim(),
    regionName: Yup.string().required('Region name is required.').trim(),
  });

  const {
    control,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm({
    defaultValues: props.region,
    resolver: yupResolver(validationSchema),
  });

  const showError = (error: string) => {
    errors.current.show({ severity: 'error', summary: 'Error:', detail: error, life: 10000 });
  };

  const onSave = (region: Region) => {
    setLoading(true);

    const addOrUpdate = isNew ? regionService.createRegion(region) : regionService.updateRegion(region);

    addOrUpdate
      .then(() => {
        props.onSave();
        props.onHide();
      })
      .catch((error) => {
        showError(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const footerTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary p-button-text" onClick={props.onHide} />
        <Button
          label="Save"
          icon="pi pi-check"
          className="p-button-primary p-button"
          onClick={handleSubmit(onSave)}
          loading={loading}
        />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <Dialog
        visible={true}
        style={{ width: '75vw' }}
        header="Region Details"
        modal
        footer={footerTemplate}
        onHide={props.onHide}
        className="p-fluid p-input-filled"
      >
        {loading && <ProgressBar mode="indeterminate" className="mb-3" />}
        <Messages ref={errors} />
        <form>
          <div className="formgrid grid">
            <div className="field col-12 md:col-6">
              {GetInputTextTemplate(control, formErrors, 'regionId', 'Region Id', { disabled: !isNew })}
            </div>
            <div className="field col-12 md:col-6">
              {GetInputTextTemplate(control, formErrors, 'regionName', 'Name', {})}
            </div>
          </div>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default RegionModal;
